import { render } from "./Instrumentation.vue?vue&type=template&id=8120d024"
import script from "./Instrumentation.vue?vue&type=script&lang=js"
export * from "./Instrumentation.vue?vue&type=script&lang=js"
script.render = render

export default script